import { useTran } from "@/hooks";
import { Button } from "@/components/ui/button";
import { FileText, PlusCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { PATHS } from "@/lib/router";

const ESGReportsEmptyState = () => {
  const { t } = useTran();
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center gap-4 rounded-radius border border-dashed border-border bg-card/40 p-10 text-center">
      <span className="flex h-12 w-12 items-center justify-center rounded-radius bg-primary/10 text-primary">
        <FileText className="h-6 w-6" />
      </span>
      <div className="space-y-1">
        <p className="text-base font-semibold text-foreground">
          {t("No ESG reports yet")}
        </p>
        <p className="text-sm text-muted-foreground">
          {t("Create your first report to track progress and disclosures.")}
        </p>
      </div>
      <Button onClick={() => navigate(PATHS.ESG_FRAMEWORKS)}>
        <PlusCircle />
        {t("Create Report")}
      </Button>
    </div>
  );
};

export default ESGReportsEmptyState;
